import React, { Component } from 'react';
import {
  Modal,
  Panel,
  Button,
  Table
}                              from "react-bootstrap";
import JSONPretty from 'react-json-pretty';
import moment from 'moment';

import CrudComponent           from "../zynappse-crud";
import schema from "./APILogs_schema.js";
import { IS_VALID } from 'utils';

class APILogs extends Component {
  constructor (props) {
    super(props);

    this.state = {
      showModal: false,
      selectedData: null
    };
  }

  render () {
    const {
      showModal,
      selectedData
    } = this.state;

    const crudProps = {
      schema,
      moduleQuery: [
        { method: "descending", column: "createdAt" }
      ],
      customView: (item) => {
        this.setState({
          showModal: true,
          selectedData: item
        });
      }
    };
    
    return (
      <div>
        <Panel>
          <Panel.Heading style={{
            backgroundColor: '#D1282F',
            color: 'white'
          }}>
            <h4>APILog</h4>
          </Panel.Heading>
          <Panel.Body>
            <CrudComponent {...crudProps}/>
          </Panel.Body>
        </Panel>
        <Modal
            show={showModal}
            onHide={() => {
              this.setState({
                showModal: false,
                selectedData: null
              });
            }}
        >
            <Modal.Header closeButton>
                <Modal.Title>VIEW</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <View
                {...{
                  selectedData
                }}
              />
            </Modal.Body>
            <Modal.Footer>
              <Button
                  onClick={() => {
                    this.setState({
                      showModal: false,
                      selectedData: null
                  });
                }}
              >
                CLOSE
              </Button>
            </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

class View extends Component {
  render () {
    const {
      selectedData
    } = this.props;''

    const GET_VALUE = (key) => {
      if (
          IS_VALID(selectedData) &&
          IS_VALID(selectedData.get(key))
      ) {
          let value = "";

          if (
              key === "createdAt" ||
              key === "updatedAt"
          ) {
              value = moment(selectedData.get(key)).format("MM/DD/YYYY hh:mm:ss A");
          } else if (key === "params" || key === "response") {
              value = selectedData.get(key) ? <JSONPretty id={key} data={selectedData.get(key) }/> : ''
          } else {
              value = selectedData.get(key);
          }

          return value;
      } else {
          return "";
      }
    }

    let data = [
      {
        label: "End Point",
        value: GET_VALUE("endPoint")
      },
      {
        label: "API Key",
        value: GET_VALUE("apiKey")
      },
      {
        label: "Network IP",
        value: GET_VALUE("networkIp")
      },
      {
        label: "Parameters",
        value: GET_VALUE("params")
      },
      {
        label: "Response",
        value: GET_VALUE("response")
      },
      {
        label: "Date",
        value: GET_VALUE('createdAt')
      }
    ];

    return (
      <Table
        bordered
        responsive
      >
        <tbody>
          {data.map((item, index) => (
            <tr id={index}>
              <td>
                <b>{item.label}</b>
              </td>
              <td>{item.value}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    )
  }
}
export default APILogs;


// WEBPACK FOOTER //
// ./components/Logs/APILogs.js